import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/coghent.svg'


const _withScopeId = n => (_pushScopeId("data-v-6daa2492"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-3 sm:mt-0 items-center flex justify-between flex-wrap sm:flex-nowrap mt-0 sm:mx-5" }
const _hoisted_2 = { class: "flex gap-2 xl:gap-8" }
const _hoisted_3 = { class: "flex flex-col items-center sm:mt-0 mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  href: "logo"
}, null, -1))
const _hoisted_5 = { class: "sm:flex flex-col items-center mt-5 ml-2 hidden" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row gap-8"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "md:text-lg -mt-3 md:-mt-0 lg:mt-0 text-center group-hover:underline cursor-pointer" }
const _hoisted_9 = {
  key: 0,
  class: "sm:inline-flex flex ml-3 mt-5"
}
const _hoisted_10 = { class: "sm:inline-flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-t-2 w-auto mb-5 border-background-dark mt-5 border-opacity-70" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "flex items-center sm:ml-0 ml-3 group cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkAction && _ctx.checkAction(...args)))
          }, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", {
                class: _normalizeClass(["md:text-lg text-center group-hover:underline", { [`font-bold`]: _ctx.isHomeActive }])
              }, _toDisplayString(_ctx.t('header.discover')), 3),
              _createElementVNode("div", {
                class: _normalizeClass(["w-2 h-2 mt-2", { [`bg-accent-yellow rounded`]: _ctx.isHomeActive }])
              }, null, 2)
            ])
          ])
        ]),
        (!_ctx.route.query.touch && !_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerItems, (menuItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: menuItem.title,
                  class: "group sm:flex flex-col items-center pt-8 md:pt-5 hidden"
                }, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: menuItem.link,
                    class: "flex items-center"
                  }, [
                    _createElementVNode("h2", _hoisted_8, _toDisplayString(menuItem.title), 1)
                  ], 8, _hoisted_7)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.route.query.touch && _ctx.useAuthFeature === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              (!_ctx.route.query.touch && !_ctx.userStore.hasUser)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    text: _ctx.t('buttons.login'),
                    "on-click": _ctx.goToLoginPage,
                    "custom-style": "primary",
                    "icon-shown": false,
                    class: "px-2 mx-1 mb-2 flex-grow-0"
                  }, null, 8, ["text", "on-click"]))
                : _createCommentVNode("", true),
              (_ctx.userStore.hasUser)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 1,
                    text: _ctx.t(`profile.greeting`) + `,  ` + _ctx.user.given_name || _ctx.user.name,
                    "on-click": _ctx.goToProfilePage,
                    "custom-style": "ghost-purple",
                    "icon-shown": false,
                    class: "px-2 mx-1"
                  }, null, 8, ["text", "on-click"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.userStore.hasUser && _ctx.useStoryboxFeature && !_ctx.isMobile && !_ctx.route.query.touch)
              ? (_openBlock(), _createBlock(_component_base_button, {
                  key: 0,
                  "has-badge": true,
                  "badge-value": _ctx.storyboxCount.toString(),
                  text: _ctx.t('buttons.storybox'),
                  "on-click": _ctx.goToVerhalenBox,
                  "custom-style": "ghost-purple",
                  "icon-shown": true,
                  "custom-icon": "storybox",
                  class: "px-2 mx-3 ml-3 hidden lg:inline-flex"
                }, null, 8, ["badge-value", "text", "on-click"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "flex justify-center items-center mx-4 stroke-gray cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleOnBoarding && _ctx.toggleOnBoarding(...args)))
            }, [
              _createVNode(_component_BaseIcon, {
                width: 30,
                height: 30,
                icon: "help"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_11
  ], 64))
}